$(function(){
	$(window).scroll(function () {
		var btn = $('.back-to-top-btn'),
			el = $('body'),
			elTop = el.offset().top,
			elHeight = el.outerHeight(),
			windowHeight = $(window).height(),
			windowScrollTop = $(this).scrollTop();
		if (!btn.is(':animated')) {
			if (windowScrollTop > windowHeight) {
				btn.stop().fadeIn();
			} else {
				btn.stop().fadeOut();
			}
		}
	});
	$('.back-to-top-btn').on('click', function () {
		// $(window).scrollTo(0, 500, {easing: 'easeOutCubic'});
		$(window).scrollTo(0, 300);
	});
});
